export enum AppStorage {
  Udid = 'udid',
  Theme = 'theme',
}
